export default "__VITE_ASSET__IlpXhpSf__"